/* eslint-disable react-hooks-ext/exhaustive-deps -- TODO(react-hooks): 2 hook(s) need dependency review; fix each and remove this directive */
import { useEffect } from "react";

/**
 * The validator handle a wrapped field talks to — the object `useFormValidator` returns,
 * narrowed to the two members these wrappers actually touch: `validate` is called here and
 * `error` is read by `ValidationWrapperWeb`.
 *
 * Declared structurally rather than as `ReturnType<typeof useFormValidator>` because the same
 * handle also arrives via the `formValidatorStore` Redux slice and via `useForms`, and both of
 * those paths pass it on without importing the hook. Both members are optional because
 * `questionFields.tsx` falls back to `{}` when no validator has been supplied.
 */
export interface FieldValidatorHandle {
  validate?: (field: { value: unknown; name: string }) => boolean;
  error?: Record<string, string>;
}

/** Props shared by `ValidationWrapperWeb` and this hook. */
export interface ValidationWrapperProps {
  /** Field name; also the key the error message is stored under. */
  name?: string;
  /** Current answer. Re-validated whenever its string form changes. */
  value?: unknown;
  validator?: FieldValidatorHandle;
  /** Extra values that should also re-trigger validation; spread into the effect deps. */
  dependencies?: unknown[];
}

const useValidationWrapper = (props: ValidationWrapperProps) => {
  const { value, name, validator, dependencies = [] } = props;
  // `value` is whatever the field type stores (string, array, file metadata, …). Only its
  // string form is used, as an effect dependency.
  const valueString = value && (value as { toString: () => string }).toString();
  useEffect(() => {
    if (validator && name && validator.validate) {
      validator.validate({ value, name });
    }
  }, [valueString, ...dependencies]);
  return {};
};

export default useValidationWrapper;
